import * as React from 'react';
import { InputBaseModel } from '../models';
import { useAppStore } from '../stores';

export default <T extends { disabled?: boolean }>(input: InputBaseModel, props: T) => {
    const { worksheetsStore } = useAppStore();

    const [disabled, setDisabled] = React.useState<boolean | undefined>();

    const worksheet = React.useMemo(
        () => worksheetsStore.worksheets.find(w => w.id === input.worksheetId),
        [worksheetsStore.worksheets, input.worksheetId]
    );

    React.useEffect(() => {
        if (input.isReadOnly || worksheet?.isLocked) {
            setDisabled(true);
            return;
        }

        setDisabled(props.disabled);
    }, [props.disabled, input.isReadOnly, worksheet?.isLocked]);

    return {
        disabled
    };
};
